import {Grid, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import clsx from "clsx";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
  img: {
    width: 317,
    height: 200,
    cursor:'pointer',
    '@media (max-width: 1800px)': {
      width: 285,
      height: 166,
    },
  },
  checkTitle: {
    color: '#212D40',
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  disableText: {
    color: '#D9D9D9'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    position: 'relative',
    '@media (max-width: 1400px)': {
      marginTop: 20,
    },
  },
  infoIcon: {
    width: 30,
    height: 30,
    cursor: 'pointer'
  },
  infoDiv: {
    width: 230,
    height: 'auto',
    borderRadius: 20,
    backgroundColor: '#F0F0F0',
    position: 'absolute',
    bottom: -140,
    zIndex: 100,
    padding: '15px 20px',
    fontSize: 14
  },
  infoTitle: {
    fontFamily: 'roboto-bold'
  },
  infoDescription: {
    fontFamily: 'roboto-regular'
  }
}));

function TrialFirstChoice() {
  const classes = useStyles();
  const { userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { path } = userMetrics;
  const [preRecordImg, setPreRecordImg] = useState("/assets/icons/pre-recorded2.svg");
  const [liveImg, setLiveImg] = useState("/assets/icons/live2.svg");
  const [overlay1, setOverlay1] = useState(false);
  const [overlay2, setOverlay2] = useState(false);

  useEffect(() => {
    if (history.location.hash !== '#first') {
      UtilService.addHashTag(history, location.pathname, 'first');
    }
  }, []);

  useEffect(() => {
    if (path === 1) {
      setPreRecordImg("/assets/icons/pre-recorded.svg")
    } else {
      setPreRecordImg("/assets/icons/pre-recorded2.svg")
    }
    if (path === 2) {
      setLiveImg("/assets/icons/live.svg")
    } else {
      setLiveImg("/assets/icons/live2.svg")
    }
  },[path]);

  const onSelectPrerecorded = () => {
    dispatch(updateUserMetrics('trialFirstStep', false));
    dispatch(updateUserMetrics('path', 1));
  };

  const onSelectLiveExperience = () => {
    dispatch(updateUserMetrics('trialFirstStep', false));
    dispatch(updateUserMetrics('path', 2));
  };

  return (
    <>
      <p className={"creator-title"} style={{ marginTop: -50 }}>
        Let’s measure some brains!
      </p>
      <p className='creator-main-title'>
        What are you measuring?
      </p>

      <Grid container alignItems='center' justifyContent='center' spacing={1}>
        <Grid item xs={12} md={6} className={classes.item}>
          <img
            className={classes.img}
            alt="{img}"
            src={preRecordImg}
            onClick={onSelectPrerecorded}
            onMouseOver={e => (e.currentTarget.src = "/assets/icons/pre-recorded.svg")}
            onMouseOut={e => path === 1 ? e.currentTarget.src = "/assets/icons/pre-recorded.svg" : e.currentTarget.src = "/assets/icons/pre-recorded2.svg"}
          />
          <p className={clsx(classes.checkTitle, path === 2 && classes.disableText)}>Pre-recorded content</p>
          <img
            className={classes.infoIcon}
            alt="Info Icon"
            src={'/assets/icons/info.svg'}
            onMouseOver={() => setOverlay1(true)}
            onMouseOut={() => setOverlay1(false)}
          />
          {overlay1 && (
            <div className={classes.infoDiv}>
              <div className={classes.infoTitle}>Examples include:</div>
              <div className={classes.infoDescription}>Ads</div>
              <div className={classes.infoDescription}>Movie Trailers</div>
              <div className={classes.infoDescription}>Songs</div>
              <div className={classes.infoDescription}>Videos</div>
              <div className={classes.infoDescription}>Recorded Lessons</div>
            </div>
          )}
        </Grid>
        <Grid item xs={12} md={6} className={classes.item}>
          <img
            className={classes.img}
            alt="{img}"
            src={liveImg}
            onClick={onSelectLiveExperience}
            onMouseOver={e => (e.currentTarget.src = "/assets/icons/live.svg")}
            onMouseOut={e => path === 2 ? e.currentTarget.src = "/assets/icons/live.svg" : e.currentTarget.src = "/assets/icons/live2.svg"}
          />
          <p className={clsx(classes.checkTitle, path === 1 && classes.disableText)}>Live experience</p>
          <img
            className={classes.infoIcon}
            alt="Info Icon"
            src={'/assets/icons/info.svg'}
            onMouseOver={() => setOverlay2(true)}
            onMouseOut={() => setOverlay2(false)}
          />
          {overlay2 && (
            <div className={classes.infoDiv}>
              <div className={classes.infoTitle}>Examples include:</div>
              <div className={classes.infoDescription}>Events</div>
              <div className={classes.infoDescription}>Classes & Lessons</div>
              <div className={classes.infoDescription}>Conferences</div>
              <div className={classes.infoDescription}>Live Performances</div>
              <div className={classes.infoDescription}>Tours & Attractions</div>
            </div>
          )}
        </Grid>

    </Grid>
    </>

  )


}

export default TrialFirstChoice;